import { Box, makeStyles, Typography } from "@material-ui/core";
import { useEffect } from "react";
import { useRedirect } from "react-admin";
import { useLocation } from "react-router-dom";
import { ImageButton } from "../../../../components/image-button/image-button.component";
import { product_logo, product_subtitle } from "../../../../utils/functions";

const useStyles = makeStyles(({ theme }) => ({
    greetingsContainer: {
        marginTop: '32px',
        display: 'flex',
        flexDirection: 'column'
    },
    name: {
        fontSize: '28px',
        fontWeight: 'bolder',
        alignSelf: 'center',
        flexGrow: 1
    },
    products_container: {
        marginBlock: '48px',
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    product_subtitles: {
        marginBottom: '48px',
        textAlign: 'center',
        fontSize: '12px',
        fontWeight: 'bolder',
        marginTop: '4px'
    }
}))

export const ProductSelector = ({ user, products, contexts, finishLogin, ...props }) => {

    const redirect = useRedirect()
    const styles = useStyles()
    const location = useLocation()
    const queryProductId = new URLSearchParams(location.search).get('product')
    const queryNextProductId = new URLSearchParams(location.state?.nextSearch).get('product')

    useEffect(() => {
        products.forEach((product) => {
            const img = new Image();
            img.src = product_logo(product.id);
        });
    }, [products]);

    const handleClick = (product) => {
        finishLogin(user.username, user.password, user.context, product, contexts, redirect)
    }

    useEffect(() => {
        let matchedProduct = queryProductId && products.find(product => String(product.id) === queryProductId)
        if (matchedProduct) {
            handleClick(matchedProduct)
        }
        matchedProduct = queryNextProductId && products.find(product => String(product.id) === queryNextProductId)
        if (matchedProduct) {
            handleClick(matchedProduct)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Box>
            <Box className={styles.greetingsContainer}>
                <Typography>Olá,</Typography>
                <Typography className={styles.name}>{user.name}!</Typography>
                <Typography>Selecione abaixo o sistema que deseja acessar.</Typography>
            </Box>
            <Box className={styles.products_container}>
                {products?.sort((a, b) => a.id - b.id).map(product => (
                    <Box>
                        <ImageButton
                            url={product_logo(product.id)}
                            title={product.name}
                            width={'100%'}
                            height={'90px'}
                            onClick={() => handleClick(product)}
                        />
                        <Typography className={styles.product_subtitles}>
                            {product_subtitle(product.id)}
                        </Typography>
                    </Box>))}
            </Box>
        </Box>
    )
}